var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { isEmpty, keys } from "ramda";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withRouter } from "react-router-dom";
import { maybe } from "tsmonads";
import { WebSocketMessage } from "../../serverConnection";
import CountrySelect from "../common/CountrySelect";
import EnterpriseSelect from "../common/EnterpriseSelect";
import IndustrySelect from "../common/IndustrySelect";
import InputField from "../common/InputField";
var validate = function (user) {
    var errors = {};
    if (isEmpty(user.firstName)) {
        errors.firstName = "You must provide a value";
    }
    if (isEmpty(user.lastName)) {
        errors.lastName = "You must provide a value";
    }
    if (isEmpty(user.company)) {
        errors.company = "You must provide a value";
    }
    if (isEmpty(user.address)) {
        errors.address = "You must provide a value";
    }
    if (isEmpty(user.city)) {
        errors.city = "You must provide a value";
    }
    if (isEmpty(user.postalCode) && user.country === "DE") {
        errors.postalCode = "You must provide a value";
    }
    if (!user.email) {
        errors.email = "Required";
    }
    else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(user.email)) {
        errors.email = "Invalid email address";
    }
    return errors;
};
var EditUser = /** @class */ (function (_super) {
    __extends(EditUser, _super);
    function EditUser(props) {
        var _this = _super.call(this, props) || this;
        _this.updateUser = function () {
            _this.props.send(WebSocketMessage("users", "update", _this.state));
            _this.props.history.push("/users");
        };
        _this.state = maybe(props.users.get(props.match.params.id)).unsafeLift();
        return _this;
    }
    EditUser.prototype.render = function () {
        var _this = this;
        var _a;
        var user = this.state;
        var setUser = this.setState.bind(this);
        var errors = validate(user);
        var remaining = function (key) {
            var ents = _this.props.enterprises.filter(function (en) { return user.enterprises.findIndex(function (ent, i) { return ent === en.id && i !== key; }) === -1; });
            return ents;
        };
        var enterpriseSelectors = user.enterprises.map(function (e, key) {
            return (React.createElement(EnterpriseSelect, { key: key, value: e, enterprises: remaining(key), setEnterprise: function (id) {
                    var enterprises = __spreadArrays(user.enterprises);
                    if (id !== "none") {
                        enterprises[key] = id;
                    }
                    else {
                        enterprises.splice(key, 1);
                    }
                    _this.setState({ enterprises: enterprises });
                }, error: key === 0 ? errors.enterprises : undefined }));
        });
        if (user.enterprises.length < this.props.enterprises.length) {
            enterpriseSelectors.push(React.createElement(EnterpriseSelect, { key: "new", value: "none", enterprises: remaining(-1), setEnterprise: function (id) {
                    var enterprises = __spreadArrays(user.enterprises);
                    enterprises.push(id);
                    _this.setState({ enterprises: enterprises });
                }, error: enterpriseSelectors.length === 0 ? errors.enterprises : undefined }));
        }
        return (React.createElement("div", { className: "container content" },
            React.createElement("div", { className: "container" },
                React.createElement("h5", null, "Edit User"),
                React.createElement("br", null),
                React.createElement("form", { onSubmit: function (e) { return e.preventDefault(); } },
                    React.createElement("div", { className: "card-panel" },
                        React.createElement(InputField, { label: "First name", type: "text", placeholder: "", meta: { touched: true, error: errors.firstName }, onChange: function (firstName) { return setUser(__assign(__assign({}, user), { firstName: firstName })); }, value: user.firstName }),
                        React.createElement(InputField, { label: "Last name", type: "text", placeholder: "", meta: { touched: true, error: errors.lastName }, onChange: function (lastName) { return setUser(__assign(__assign({}, user), { lastName: lastName })); }, value: user.lastName }),
                        React.createElement(InputField, { label: "Company", type: "text", placeholder: "", meta: { touched: true, error: errors.company }, onChange: function (company) { return setUser(__assign(__assign({}, user), { company: company })); }, value: user.company })),
                    React.createElement("div", { className: "card-panel" },
                        React.createElement(InputField, { label: "Address", type: "text", placeholder: "", meta: { touched: true, error: errors.address }, onChange: function (address) { return setUser(__assign(__assign({}, user), { address: address })); }, value: user.address }),
                        React.createElement(InputField, { label: "City", type: "text", placeholder: "", meta: { touched: true, error: errors.city }, onChange: function (city) { return setUser(__assign(__assign({}, user), { city: city })); }, value: user.city }),
                        user.country === "DE" && (React.createElement(InputField, { label: "Postal code", type: "text", placeholder: "", meta: { touched: true, error: errors.postalCode }, onChange: function (postalCode) { return setUser(__assign(__assign({}, user), { postalCode: postalCode })); }, value: user.postalCode })),
                        React.createElement("div", null,
                            React.createElement(CountrySelect, { value: user.country, onChange: function (e) { return setUser(__assign(__assign({}, user), { country: e.target.value })); }, enterprises: this.props.enterprises }),
                            user.role === "customer" && (React.createElement(IndustrySelect, { value: (_a = user.industry) !== null && _a !== void 0 ? _a : "", onChange: function (e) { return setUser(__assign(__assign({}, user), { industry: e.target.value })); } })),
                            user.role === "customer" && (React.createElement(React.Fragment, null,
                                React.createElement("br", null),
                                React.createElement(InputField, { value: this.state.isHost, placeholder: "Is host?", onChange: function () {
                                        _this.setState(__assign(__assign({}, user), { isHost: !_this.state.isHost }));
                                    }, type: "checkbox", label: "Is Host?" }))),
                            enterpriseSelectors),
                        React.createElement("br", null),
                        React.createElement("br", null)),
                    React.createElement(Link, { to: "/users", className: "white btn-flat left red-text" }, "Cancel"),
                    React.createElement("button", { className: "teal btn-flat btn right white-text", onClick: function () { return _this.updateUser(); }, disabled: keys(errors).length > 0 }, "Update user"),
                    React.createElement("br", null),
                    React.createElement("br", null)))));
    };
    return EditUser;
}(Component));
export default withRouter(EditUser);



//////////////////
// WEBPACK FOOTER
// ./src/components/users/EditUser.tsx
// module id = 1234
// module chunks = 0